import * as React from "react";
import { SVGProps } from "react";
export const ArrowDownIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M10 16.312C9.88868 16.312 9.78102 16.288 9.67702 16.24C9.57302 16.1913 9.47235 16.1253 9.37502 16.042L3.93802 10.604C3.77135 10.4373 3.69135 10.2327 3.69802 9.99C3.70468 9.74667 3.79135 9.54167 3.95802 9.375C4.12468 9.20833 4.32602 9.125 4.56202 9.125C4.79868 9.125 5.00035 9.20833 5.16702 9.375L9.12502 13.333V4.208C9.12502 3.972 9.21168 3.76733 9.38502 3.594C9.55902 3.42 9.76402 3.333 10 3.333C10.236 3.333 10.441 3.42 10.615 3.594C10.7883 3.76733 10.875 3.972 10.875 4.208V13.333L14.833 9.375C14.9997 9.20833 15.2047 9.125 15.448 9.125C15.6907 9.125 15.8953 9.20833 16.062 9.375C16.2287 9.54167 16.312 9.74667 16.312 9.99C16.312 10.2327 16.2287 10.4373 16.062 10.604L10.625 16.042C10.5417 16.1253 10.4444 16.1913 10.333 16.24C10.2224 16.288 10.1114 16.312 10 16.312Z"
            fill="currentColor"
        />
    </svg>
);
ArrowDownIcon.displayName = "ArrowDownIcon";
